import { render, staticRenderFns } from "./phone-why-link.vue?vue&type=template&id=40d2a93b&scoped=true&"
import script from "./phone-why-link.vue?vue&type=script&lang=js&"
export * from "./phone-why-link.vue?vue&type=script&lang=js&"
import style0 from "./phone-why-link.vue?vue&type=style&index=0&id=40d2a93b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d2a93b",
  null
  
)

export default component.exports